export enum ACTION {
  EDIT_UNIT = "EDIT_UNIT",
  REMOVE_UNIT = "REMOVE_UNIT",
  DEFAULT_ACTION = "DEFAULT_ACTION",
  EDIT_CONTROLLER = "EDIT_CONTROLLER",
  REMOVE_CONTROLLER = "REMOVE_CONTROLLER",
  VIEW_LOCATION = "VIEW_LOCATION",
  EDIT_LOCATION = "EDIT_LOCATION",
}

export enum ACT {
  NEW = "NEW",
  EDIT = "EDIT",
  DELETE = "DELETE",
}

export enum TYPE {
  UNIT = "UNIT",
  CONTROLLER = "CONTROLLER",
}
